module.exports = __webpack_public_path__ + "media/land-for-sale.080baf5a.svg";